<h1>Sesjonen din har utløpt.</h1>

<p>For å være helt sikker på at ingen andre brukere får tilgang til Minsak, bør du lukke dette vinduet. Hvis du fortsatt ønsker å registrere en klage, 
    lukk dette vinduet og start på nytt.</p>
